import { OddsButton } from '@/components/widgets/odds-button';
import { useTranslations } from 'next-intl';
import { useAccountInfo } from '@/hooks/query/account';
import { BetTypeContentProps } from '../bet-type-content';
import { BetChoices } from '@/types/bet-type-settings';
import { useGetBetTypeSetting } from '@/hooks';

export const BetTypeCol2FastMarket = ({ matchModel, betTypeArray }: BetTypeContentProps) => {
	const getBetTypeSetting = useGetBetTypeSetting();
	const market = betTypeArray[0];
	const t = useTranslations('General');

	const { user } = useAccountInfo();

	const betTypeId = betTypeArray[0].BetTypeId;
	const { betChoices } = getBetTypeSetting(betTypeId, matchModel.GameID);

	const groupChoices = betChoices.sort((a, b) => {
		// 先依照betChoiceGroup排序
		return (a.betChoiceGroup ?? 0) - (b.betChoiceGroup ?? 0);
	}).reduce((groupChoices, choice) => {
		const existingGroup = groupChoices.find(choices => choices.some(targetChoice => targetChoice.betChoiceGroup == choice.betChoiceGroup));

		if (existingGroup) {
			existingGroup.push(choice);
		} else {
			groupChoices.push([choice]);
		}

		return groupChoices;
	}, new Array<Array<BetChoices>>());

	return (
		<div className="bettype__content bettype__content--col-2">
			{
				groupChoices.map(group => {
					return (
						<>
							<div className="bettype__list">
								{
									group.map(choice => {
										return choice.label ?
											<div key={choice.betTeam} className="bettype__title">{t(choice.label)}</div> :
											<div key={choice.betTeam} className="bettype__title" />;
									})
								}
							</div>
							<div className="bettype__list">
								{
									group.map((choice, idx) => {
										if (!choice.betTeam) {
											return <div key={idx} />;
										}
										const line = choice.line ?
											market.Selections[choice.line].Price.toString() : '';
										return (
											<OddsButton
												key={`${market.Line}_${choice.betTeam}`}
												match={matchModel}
												market={market}
												selection={market.Selections[choice.betTeam]}
												homeTeamName={''}
												awayTeamName={''}
												goal={line}
												variant="vertical"
												betTeam={market.Selections[choice.betTeam].SelId}
												originalPrice={market.Selections[choice.betTeam].Price}
												sport={matchModel?.GameID}
												type="OU"
												oddsType={user?.OType}
												accountStatus={user?.ActStatus ?? 0}
											/>
										)
									})
								}
							</div>
						</>
					);
				})
			}
		</div>
	)
};
